import { useEffect, useState } from "react";
import { openStatus } from "../../lib/site";

export function OpenBadge({ dark = false, testid = "live-status-badge" }) {
  const [s, setS] = useState(openStatus);
  useEffect(() => {
    const t = setInterval(() => setS(openStatus()), 30000);
    return () => clearInterval(t);
  }, []);
  const tone = s.open
    ? dark ? "bg-emerald-400/15 text-emerald-300 ring-emerald-400/30" : "bg-emerald-50 text-emerald-700 ring-emerald-600/20"
    : dark ? "bg-white/10 text-slate-200 ring-white/20" : "bg-slate-100 text-slate-700 ring-slate-300";
  return (
    <span data-testid={testid} className={`inline-flex items-center gap-2 rounded-full px-3 py-1 text-xs font-semibold ring-1 ${tone}`}>
      <span className="relative flex h-2 w-2">
        {s.open && <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-emerald-400 opacity-70" />}
        <span className={`relative inline-flex h-2 w-2 rounded-full ${s.open ? "bg-emerald-500" : "bg-slate-400"}`} />
      </span>
      {s.label}
    </span>
  );
}
